import { IApplicationContext } from '../../types/applicationContext';
import { makeContextModule } from '../../utils/makeContextModule';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
